module.exports = __webpack_public_path__ + "static/media/dpmo.a2b54f8d.png";